export const ApiUrls = {
    dashboard:'account/admin/dashboard/dashboardApi',
}